"use client";

import { useEffect } from "react";

import { reloadOnceForStaleBuild } from "@/app/stale-build-recovery";

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    if (reloadOnceForStaleBuild(error)) {
      return;
    }
    // Surface the stack to the console but don’t crash
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="space-y-4 text-center">
        <h1 className="text-2xl font-bold">Something went wrong</h1>
        <p className="text-muted-foreground">Try refreshing the page or come back later</p>
        <button
          onClick={reset}
          className="rounded-md bg-primary px-4 py-2 text-white hover:bg-primary/90"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
